import { Html } from '@react-three/drei'
import { useState } from 'react'
import { getSocket } from '../socket'

const socket = getSocket()
const modalFont = "'Luckiest Guy', 'Noto Sans SC', sans-serif"
const chineseNameFont = "'Noto Sans SC', sans-serif"

export default function PlayerNameModal({ name, onClose }) {
  const [nextName, setNextName] = useState(name)
  const [alert, setAlert] = useState('')
  const nameFont = /[\u3400-\u9fff\uf900-\ufaff]/u.test(nextName) ? chineseNameFont : modalFont

  function submit(event) {
    event.preventDefault()
    const trimmedName = nextName.trim()
    if (trimmedName.length === 0) {
      setAlert('Enter a name.')
      return
    }
    if (trimmedName.length > 15) {
      setAlert('Must be 15 characters or fewer.')
      return
    }
    if (!/^[\p{L}\p{N} ]+$/u.test(trimmedName)) {
      setAlert('Can only contain letters and numbers.')
      return
    }
    socket.emit('renamePlayer', { name: trimmedName }, ({ error } = {}) => {
      if (error) {
        setAlert(error)
        return
      }
      onClose()
    })
  }

  return <Html center transform position={[0, 0.5, 0]}>
    <form onSubmit={submit} style={{ position: 'absolute' }}>
      <div style={{ boxSizing: 'border-box', width: '330px', backgroundColor: 'black', border: '2px solid #F1EE92', padding: '16px' }}>
        <p style={{ color: '#F1EE92', fontFamily: modalFont, fontSize: '26px', margin: '0 0 14px', textAlign: 'center' }}>SET NAME</p>
        <input autoFocus maxLength={15} value={nextName} onChange={(event) => setNextName(event.target.value)} style={{ boxSizing: 'border-box', width: '100%', minHeight: '48px', background: 'none', color: '#F1EE92', border: '2px solid #F1EE92', fontFamily: nameFont, fontSize: '22px', padding: '8px 10px' }} />
        <p style={{ minHeight: '17px', color: 'red', fontFamily: modalFont, fontSize: '14px', margin: '8px 0' }}>{alert}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <button type='submit' style={{ background: 'none', border: '2px solid #F1EE92', color: '#F1EE92', fontFamily: modalFont, fontSize: '19px', padding: '7px 10px' }}>SAVE</button>
          <button type='button' onClick={onClose} style={{ background: 'none', border: '2px solid red', color: 'red', fontFamily: modalFont, fontSize: '19px', padding: '7px 10px' }}>CANCEL</button>
        </div>
      </div>
    </form>
  </Html>
}